<template>
  <div>
    <el-table
      size="mini"
      :data="visibleReceivers"
      :default-sort="{ prop: sortedColumn, order: sortedDirection }"
      stripe
      @sort-change="sortReceivers"
    >
      <el-table-column
        prop="label"
        label="Receiver"
        min-width="160"
        fixed
        show-overflow-tooltip
      />

      <el-table-column
        prop="cost"
        label="Cost"
        width="100"
        :formatter="formatCurrency"
        sortable="custom"
      />

      <el-table-column
        prop="consignments"
        label="Consignments"
        width="140"
        :formatter="formatNumber"
        sortable="custom"
      />

      <el-table-column
        prop="items"
        label="Items"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      />

      <el-table-column
        prop="volume"
        label="Volume"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ formatNumber(undefined, undefined, scope.row.volume) }}m<sup>3</sup>
        </template>
      </el-table-column>

      <el-table-column
        prop="weight"
        label="Weight"
        width="100"
        :formatter="formatNumber"
        sortable="custom"
      >
        <template slot-scope="scope">
          {{ formatNumber(undefined, undefined, scope.row.weight) }}kg
        </template>
      </el-table-column>
    </el-table>

    <div class="clearfix" />

    <el-pagination
      class="pt-4 w-100 text-center"
      layout="prev, pager, next"
      :pager-count="5"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      :total="totalReceivers"
      background
      hide-on-single-page
      @current-change="setCurrentPage"
    />
  </div>
</template>

<script>
export default {
  props: {
    receivers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      pageSize: 8,
      currentPage: 1,
      sortedColumn: 'cost',
      sortedDirection: 'descending'
    }
  },
  computed: {
    totalReceivers () {
      return this.receivers.length
    },
    sortedReceivers () {
      const allReceivers = this.receivers
      const clonedReceivers = (JSON.parse(JSON.stringify(allReceivers)))
      const sortedColumn = this.sortedColumn
      const sortedDirection = this.sortedDirection

      return clonedReceivers.sort((a, b) => {
        return (sortedDirection === 'ascending' ? parseFloat(a[sortedColumn]) > parseFloat(b[sortedColumn]) : parseFloat(a[sortedColumn]) < parseFloat(b[sortedColumn]))
      })
    },
    visibleReceivers () {
      const currentPage = this.currentPage
      const pageSize = this.pageSize
      const sortedReceivers = this.sortedReceivers

      return sortedReceivers.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    }
  },
  methods: {
    sortReceivers ({ order, prop }) {
      this.sortedColumn = prop
      this.sortedDirection = order
    },
    setCurrentPage (page) {
      this.currentPage = page
    },
    formatCurrency (row, column, cellValue) {
      return (new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      })).format(cellValue)
    },
    formatNumber (row, column, cellValue) {
      return (new Intl.NumberFormat('en-US')).format(cellValue)
    }
  }
}
</script>
